<template>
  <main class="v-main">
    <slot />
  </main>
</template>

<style>
.v-main {
  display: block;
  position: relative;
  flex: 1;
  flex-basis: auto;
  max-width: var(--max-main-width);
  width: 100%;
  margin: 0 auto;
}
</style>
